import { ComponentPropsWithoutRef, ReactNode } from 'react';

export const DesktopSidePanelShell = ({
    children,
    ...rest
}: { children: ReactNode } & ComponentPropsWithoutRef<'div'>) => (
    <div
        className="sticky top-header-offset flex min-h-[calc(100dvh-var(--header-offset))] max-w-[472px] flex-col p-2xl pt-5xl text-white"
        {...rest}
    >
        {children}
    </div>
);
